<template>
    <div class="asd">
    	<router-view></router-view>
    	<div class="header">
	      <p>园区通知</p>
	     <el-button type="primary" style="height: 35px;line-height: 10px;margin-right: 20px;">+ 新建通知</el-button>
	    </div>  
	    <el-form :inline="true" :model="formInline" class="demo-form-inline" style="text-align: left;">
		  <el-form-item label="通知标题:">
		    <el-input v-model="formInline.user" placeholder="请输入通知标题"></el-input>
		  </el-form-item>
		<el-form-item label="时间范围">
		    <el-col :span="11">
		      <el-date-picker :clearable="false"  type="date" placeholder="选择查询起始时间" v-model="formInline.date1" style="width: 100%;"></el-date-picker>
		    </el-col>
		    <el-col :span="2" style="text-align: center;">  -</el-col>
		    <el-col :span="11">
		      <el-date-picker :clearable="false"  type="date" placeholder="选择查询结束时间" v-model="formInline.date2" style="width: 100%;"></el-date-picker>
		    </el-col>
		</el-form-item>
		</el-form>
		<div class="header">
			<el-form :inline="true" :model="formInline" class="demo-form-inline" style="text-align: left;">	
			  <el-form-item label="通知人员:">
			    <el-select v-model="formInline.region" placeholder="请选择用户">
			      <el-option label="张三" value="zhangsan"></el-option>
			      <el-option label="李四" value="lisi"></el-option>
			    </el-select>
			  </el-form-item>
			</el-form> 
			<div style="margin-right: 20px;">
				 <el-button type="primary" style="height: 35px;line-height: 10px;">查询</el-button>
				  <el-button type="info" style="height: 35px;line-height: 10px;">重置</el-button>
			</div>
		</div>
		 <el-table
		    :data="tableData"
		    stripe
		    :header-cell-style="cell"
		    style="width: 100%;">
		    <el-table-column
		  	align="center"
		      prop="date"
		      label="通知标题"
		      width="180">
		    </el-table-column>
		    <el-table-column
		    	align="center"
		      prop="name"
		      label="通知人员"
		      width="180">
		    </el-table-column>
		    <el-table-column
		    	align="center"
		      prop="Time"
		      label="发表时间">
		    </el-table-column>
		    <el-table-column
		    	align="center"
		      label="操作" style="text-align: center;">
		      <template slot-scope="scope">
		        <el-button  type="text" size="small">查看</el-button>
		        <el-button type="text" size="small">编辑</el-button>
		        <el-button type="text" size="small" style="color: red;">删除</el-button>
		      </template>
		    </el-table-column>
		 </el-table>
    </div>
  
</template>

<script>

  export default {
    name: '',
    props: [''],
    data () {
      return {
      	 formInline: {
          user: '',
          region: '',
          date1: '',
	      date2: '',
        },
           tableData: [{
          date: '停电通知',
          name: '王小虎',
          Time: "2017-09-18 19:10",
        }, {
          date: '停电通知',
          name: '王小虎',
          Time: "2017-09-18 19:10",
        }, {
          date: '停电通知',
          name: '王小虎',
          Time: "2017-09-18 19:10",
        }, {
          date: '停电通知3',
          name: '王小虎',
          Time: "2017-09-18 19:10",
        }]
      };
    },
    methods: {
    	 cell(){
      	return {textAlign: 'center'}
      }
    }
  }
</script>
<style scoped>
	.header{
  	display: flex;
  	justify-content: space-between;
  }
    .asd{
		position: absolute;
		background-color: white;
		height: 81%;
		width: 82.5%;
		text-align: left;
		padding-top: 30px;
		padding-left: 30px;
	}
	
</style>



// WEBPACK FOOTER //
// src/pages/park/index.vue